import {Button, IconButton} from "@mui/material";
import {useCallback} from "react";
import {scopeToString} from "../utils/formatData";
import {FiPlus, FiTrash2} from "react-icons/fi";
import {useLocation, useNavigate} from "react-router-dom";
import ListView from "../components/ListView/ListView";
import Window from "../components/Window/Window";
import ConfirmDialog from "../components/ui/ConfirmDialog";
import {scopesColumns} from "../constants/dataGridColumns";
import useApiRequest from "../hooks/useApiRequest";
import useConfirmDialog from "../hooks/useConfirmDialog";
import usePaginationSearch from "../hooks/usePaginationSearch";
import {useAuthPermissions, ACTIONS, RESOURCES} from "../hooks/useAuthPermissions";
import {snackbar} from "../utils/snackbar";

const Scopes = () => {
  const navigate = useNavigate();
  const {state} = useLocation();
  const {list, remove} = useApiRequest({baseUrl: "/scopes", resource: "scopes"});
  const {can} = useAuthPermissions();

  const fetcher = useCallback(
    async (query) => {
      const {success, data} = await list({...query});
      if (!success) return null;
      return {data};
    },
    [list]
  );

  const {dataGridProps, refresh, listState} = usePaginationSearch({fetcher, initialListState: state?.listState});

  const {confirmOpen, itemName, openDialog, handleConfirm, handleCancel} = useConfirmDialog(async (id) => {
    const {success} = await remove(id);
    if (!success) return;

    snackbar.success("Scope eliminado correctamente.");
    refresh();
  });

  const handleScopeClick = (scope) => {
    if (!scope?.id) {
      snackbar.error("No se ha podido abrir el scope seleccionado.");
      return;
    }
    navigate(`/scope-form`, {state: {id: scope?.id, from: {pathname: "/scopes", listState}}});
  };

  const handleOpenDeleteDialog = (id) => {
    const found = dataGridProps.rows?.find((scope) => scope.id === id);
    if (found) {
      const displayName = scopeToString(found);
      openDialog(id, displayName);
    }
  };

  const columns = [
    ...scopesColumns,
    ...(can(ACTIONS.DELETE, RESOURCES.SCOPES)
      ? [
          {
            field: "actions",
            headerName: "Actions",
            width: 150,
            sortable: false,
            filterable: false,
            renderCell: (params) => {
              return (
                <IconButton
                  aria-label="delete"
                  color="error"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleOpenDeleteDialog(params.row.id);
                  }}
                >
                  <FiTrash2 />
                </IconButton>
              );
            }
          }
        ]
      : [])
  ];

  return (
    <>
      <Window
        title={"Scopes"}
        topRightButtons={
          can(ACTIONS.WRITE, RESOURCES.SCOPES) && (
          <Button
            variant="contained"
            color="primary"
            startIcon={<FiPlus />}
            onClick={() => {
              navigate(`/scope-form`);
            }}
          >
            Nuevo Scope
          </Button>
          )
        }
      >
        <ListView columns={columns} dataGridProps={dataGridProps} onRowClick={handleScopeClick} />
      </Window>

      <ConfirmDialog
        open={confirmOpen}
        onClose={handleCancel}
        onConfirm={handleConfirm}
        entityName="scope"
        entityLabel={itemName}
      />
    </>
  );
};

export default Scopes;
